import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';

import { switchMap, map, catchError } from 'rxjs/operators';
import { MwOrdersApiService } from 'app/services/orders-api.service';
import { of } from 'rxjs';
import * as notifyActions from 'app/store/general/actions/notify.actions';
import * as ordersActions from '../actions/orders.actions';

@Injectable()
export class OrdersEffects {
  constructor(
    private actions$: Actions,
    private orderApi: MwOrdersApiService
  ) {}

  loadOrders$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ordersActions.loadOrders),
      switchMap((action) => this.orderApi.getOrders(action.options)),
      map((response) => ordersActions.loadOrdersSuccess({ payload: response })),
      catchError((err) => of(ordersActions.loadOrdersFailed({ err })))
    )
  );

  createOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ordersActions.createOrder),
      switchMap(({ payload }) =>
        this.orderApi.createOrder(payload).pipe(
          switchMap((response) => [
            ordersActions.createOrderSuccess({ payload: response }),
            notifyActions.notifySuccess({
              notification: { phrase: 'OPERATION.add_order_successful' },
            }),
          ]),
          catchError((error) =>
            of(ordersActions.createOrderFailed({ err: error }))
          )
        )
      )
    )
  );

  editOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ordersActions.editOrder),
      switchMap(({ payload }) =>
        this.orderApi.editOrder(payload).pipe(
          switchMap((response) => [
            ordersActions.editOrderSuccess({ payload: response }),
            notifyActions.notifySuccess({
              notification: { phrase: 'OPERATION.edit_order_successful' },
            }),
          ]),
          catchError((error) =>
            of(ordersActions.editOrderFailed({ err: error }))
          )
        )
      )
    )
  );

  deleteOrder$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ordersActions.deleteOrder),
      switchMap(({ payload }) =>
        this.orderApi.deleteOrder(payload).pipe(
          switchMap(() => [
            ordersActions.deleteOrderSuccess(),
            notifyActions.notifySuccess({
              notification: { phrase: 'OPERATION.delete_order_successful' },
            }),
          ]),
          catchError((error) =>
            of(ordersActions.deleteOrderFailed({ err: error }))
          )
        )
      )
    )
  );
}
